// import config from "../apis/config.js"
import {mapState,mapGetters} from 'vuex'
import config from '../utils/config';

export default {
	data() {
		return {
			webImg: config.webImg, //网络图片前缀
			_lastTime: null, //上次点击时间
			isOffLine: false, //是否断网了
			// upFileUrl:'https://www.dslyjt.com/manage/api/config/uploadDesign',
			// upFileUrl:'http://192.168.1.140:8996/api/config/uploadDesign',
		};
	},
	computed: {
		...mapGetters(['isMobile'])
	},
	methods: {
		imgCut(w,h,type){
			return ''
			if(!type){
			  type = 'c'
			}
			w=parseInt(w*1.5)
			h=parseInt(h*1.5)
			return `@${w}w_${h}h_100Q_${type}`
		  },
		checkURL(URL) {
			var str = URL;
			//判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
			//下面的代码中应用了转义字符"\"输出一个字符"/"
			var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
			var objExp = new RegExp(Expression);
			if (objExp.test(str) == true) {
				return true;
			} else {
				return false;
			}
		},
		formatRichText(html) { //控制富文本图片大小
			let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
				match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
				return match;
			});
			newContent = newContent.replace(/<br[^>]*\/>/gi, '');

			newContent = newContent.replace(/\<img/gi,
				'<img style="max-width:96%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');


			return newContent;
		},
		getBeforeDate(num, time) {
			let n = num;
			let d = '';
			if (time) {
				d = new Date(time);
			} else {
				d = new Date();
			}
			let year = d.getFullYear();
			let mon = d.getMonth() + 1;
			let day = d.getDate();
			if (day <= n) {
				if (mon > 1) {
					mon = mon - 1;
				} else {
					year = year - 1;
					mon = 12;
				}
			}
			d.setDate(d.getDate() - n);
			year = d.getFullYear();
			mon = d.getMonth() + 1;
			day = d.getDate();
			let s = year + (mon < 10 ? '0' + mon : mon) + (day < 10 ? '0' + day : day);
			return s;
		},
		getBeforeDates(num, time) {
			let n = num;
			let d = '';
			if (time) {
				d = new Date(time);
			} else {
				d = new Date();
			}
			let year = d.getFullYear();
			let mon = d.getMonth() + 1;
			d.setDate(d.getDate() - n);
			year = d.getFullYear() - 1;
			let s = year + (mon < 10 ? '0' + mon : mon);
			return s;
		},
		/**
		 * 数字字段值转换 规避toFixed 精度丢失问题
		 * @param {输入的数字 string、int 类型均可} n
		 * @param {保留位数 可输入 0} d
		 * @returns
		 */
		toFixedNum(n, d) {
			// 判断是小数
			var isFloat = parseInt(n) < parseFloat(n);

			if (typeof (d) == "undefined") {
				// 获取浮点型数值的小数位数
				d = (n != Math.floor(n)) ? (n.toString()).split('.')[1].length : 0;
			}

			if (isFloat) {
				n = Number(n);
				d = Number(d);
				n = n * Math.pow(10, d);
				n = Math.round(n);
				n = Number(n);
				n = n / Math.pow(10, d);
				n = n.toFixed(d);
				n = Number(n);
			} else {
				n = Number(n);
			}

			return n;
		},
		openUrl(url) {
			let routeData = this.$router.resolve(url)
			console.log("routeData.href: ",routeData.href);
			window.open(routeData.href, '_blank')
		},
		clearBlank(value) {
			if (value) {
				value = value.replace(/\s/g, "")
			}
			return value
		},
		//数字转换为万单位
		formatNumber(num) {
			num = Number(num);
			if (num == 0) {
				return num + '';
			} else if (num > 1 && num < 10000) {
				return num + '';
			} else {
				return (num / 10000).toFixed(2);
			}
		},
		throttle(fn, gapTime) {
			if (gapTime == null || gapTime == undefined) {
				gapTime = 500 // 默认500毫秒
			}
			let _nowTime = +new Date()
			if (_nowTime - this._lastTime > gapTime || !this._lastTime) {
				fn()
				this.$message.success('刷新成功')
				this._lastTime = _nowTime
			}
		},
		getYear() {
			let date = new Date() // 如果date为13位不需要乘1000
			let Y = date.getFullYear()
			return Y
		},
		getDate(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D
		},
		getDateTime(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D
		},
		getDateTimes(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m
		},
		getDateTime1(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return h + "" + m + "" + s
		},
		getDateTime2(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ' : '
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ' : '
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m + s
		},
		//控制富文本图片大小
		formatRichText(html) {
			let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
				match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
				return match;
			});
			newContent = newContent.replace(/<br[^>]*\/>/gi, '');
			newContent = newContent.replace(/\<img/gi,
				'<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
			return newContent;
		},
	},
}



// WEBPACK FOOTER //
// ./src/mixin/index.js